
import { useNativePlatform } from "@/hooks/useNativePlatform";


interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const { isNative } = useNativePlatform();

  return (
    <div
      className={
        isNative
          ? "container mx-auto px-3 py-0 relative min-h-0"
          : "container mx-auto p-4 relative min-h-screen"
      }
    >
      {children}
    </div>
  );
};

export default DashboardLayout;
